import { StringHelper } from '../helpers';
import { MimeTypeEnum } from './content-types.model';

export class DataUrl {
  constructor(
    public base64: string,
    public mimeType?: MimeTypeEnum,
    public fileExtension?: string,
  ) {
    if (mimeType && !fileExtension) {
      this.fileExtension = DataUrl.mimeTypeToFileExtension(mimeType);
    } else if (!mimeType && fileExtension) {
      this.mimeType = DataUrl.fileExtensionToMimeType(fileExtension);
    }
  }

  private static mimeTypeToFileExtension(mimeType: MimeTypeEnum): string {
    let fileExtension: string;
    switch (mimeType) {
      case MimeTypeEnum.PNG:
        fileExtension = 'png';
        break;
      case MimeTypeEnum.JPEG:
      case MimeTypeEnum.JPG:
        fileExtension = 'jpg';
        break;
      default:
        fileExtension = '<unknown>';
        break;
    }
    return fileExtension;
  }

  private static fileExtensionToMimeType(fileExtension: string): MimeTypeEnum {
    let mimeType: MimeTypeEnum;
    fileExtension = StringHelper.trimStart(fileExtension, '.').toLowerCase();

    switch (fileExtension) {
      case 'png':
        mimeType = MimeTypeEnum.PNG;
        break;
      case 'jpg':
      case 'jpeg':
        mimeType = MimeTypeEnum.JPEG;
        break;
    }
    return mimeType;
  }

  public static fromString(dataUrl: string): DataUrl {
    const [meta, base64] = dataUrl.split(',');
    const [, mimeType] = meta.match(/data:(.*?);/)!;

    const mimeTypeEnum = mimeType as MimeTypeEnum;
    return new DataUrl(base64, mimeTypeEnum);
  }

  public toString(): string {
    return `data:${this.mimeType};base64,${this.base64}`;
  }
}
